import React from 'react';

import { DialogContext, type DialogContextInterface } from '../context/DialogContext.tsx';

const useDialog = (): DialogContextInterface => React.useContext(DialogContext);

export default useDialog;
